module.exports = __webpack_public_path__ + "static/media/followadd.f53a0c5b.svg";